export default {
	InvoiceList: {
		Attached: 'Tệp',
		File: 'Tệp đính kèm',
		InvoiceNo: 'Số hóa đơn',
		InvoiceDate: 'Ngày hóa đơn',
		MCCQT: 'Mã cơ quan thuế',
		SignedDate: 'Ngày ký',
		TaxAuthorityCreatedDate: 'Ngày gửi đến CQT',
		IssueDate: 'Ngày cấp mã',
		SupplierCode: 'Mã người bán',
		SellerName: 'Tên người bán',
		SellerAddress: 'Địa chỉ người bán',
		SellerTaxCode: 'MST người bán',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		TotalHasDiscount: 'Thành tiền trước thuế',
		TotalHasDiscountCC: 'Thành tiền trước thuế quy đổi',
		TaxReduction: 'Giảm thuế',
		TotalVATAmount: 'Tổng tiền thuế',
		TotalVATAmountCC: 'Tổng tiền thuế quy đổi',
		TotalFeesAmountXML: 'Tổng tiền phí',
		AmountOtherReduction: 'Tổng giảm trừ khác',
		TotalAmount: 'Tổng tiền',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		CostNorms: 'Định mức chi phí',
		BeyondTheNorm: 'Vượt định mức',
		NonBeyondTheNorm: 'Chưa vượt định mức',
		HasPdf: 'Bản thể hiện hóa đơn',
		HasXml: 'XML hóa đơn',
		Status: 'Kết quả kiểm tra',
		CheckDate: 'Ngày kiểm tra',
		CostType: 'Loại chi phí',
		IsSendEmail: 'Trạng thái gửi email',
		StatusInvoice: 'Trạng thái hóa đơn',
		IsRelativeInvoice: 'Hóa đơn liên quan',
		WarningPaymentDueDate: 'Ngày nhắc hạn TT',
		PaymentDueDate: 'Hạn thanh toán',
		AmountPayment: 'Trạng thái thanh toán',
		PaymentNumber: 'Số lần thanh toán',
		TotalAmountNotPayment: 'Tiền chưa thanh toán',
		CheckedVatStatus: 'Kiểm tra thuế suất',
		CompanyName: 'Công ty',
		CompanyTax: 'MST công ty',
		BranchName: 'Chi nhánh',
		BranchTax: 'MST chi nhánh',
		BuyerName: 'Tên người mua',
		'InfoND123.BuyerFullName': 'Họ tên người mua',
		BuyerAddress: 'Địa chỉ người mua',
		DepartmentName: 'Phòng ban',
		BuyerInvRevEmail: 'Email nhận hóa đơn',
		Noted: 'Ghi chú',
		RefNo: 'Số chứng từ',
		AccountingDate: 'Ngày hạch toán',
		Accountant: 'Người hạch toán',
		CreatedDate: 'Ngày vào hệ thống',
		UploadFile: 'Tệp hóa đơn',
		ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên CQT',
		ChangeStatusInvoiceOnSystemDate: 'Ngày phát hiện thay đổi trạng thái',
		NotificationWrong: 'Thông báo sai sót',
		LicensePlate: 'Biển số xe',
		TypeInvoiceReceive: 'Nguồn hóa đơn'
	},

	OutInvoiceList: {
		InvoiceNo: 'Số hóa đơn',
		InvoiceDate: 'Ngày hóa đơn',
		TaxAuthorityCreatedDate: 'Ngày gửi đến CQT',
		MCCQT: 'Mã cơ quan thuế',
		BuyerName: 'Tên người mua',
		BuyerCode: 'Mã khách hàng',
		BuyerTaxCode: 'MST người mua',
		BuyerAddress: 'Địa chỉ người mua',
		BuyerFullName: 'Họ tên người mua',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		TotalAmount: 'Tổng tiền',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		TotalHasDiscount: 'Thành tiền trước thuế',
		TotalHasDiscountCC: 'Thành tiền trước thuế quy đổi',
		TotalVATAmount: 'Tổng tiền thuế',
		TotalVATAmountExchange: 'Tổng tiền thuế quy đổi',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		StatusInvoice: 'Trạng thái hóa đơn',
		UploadFile: 'Tệp hóa đơn'
	},

	SupplierList: {
		SupplierCode: 'Mã đơn vị',
		TaxCode: 'Mã số thuế/CCCD chủ hộ',
		Name: 'Tên nhà cung cấp/khách hàng',
		Address: 'Địa chỉ',
		BusinessAmount: 'Ngành nghề kinh doanh',
		Owner: 'Người đại diện',
		CompanyName: 'Công ty',
		BranchName: 'Chi nhánh',
		DepartmentName: 'Phòng ban',
		//TotalInvoice: 'HĐ đầu vào',
		//TotalOutInvoice: 'HĐ đầu ra',
		PaymentDueDateNumber: 'Hạn thanh toán (ngày)',
		NumberAccount: 'Số tài khoản',
		NameAccount: 'Tên tài khoản',
		NameBank: 'Tên ngân hàng',
		Agency: 'Chi nhánh',
		NameContact: 'Người liên hệ',
		Email: 'Email',
		PhoneNumber: 'Số điện thoại',
		Position: 'Chức vụ',
		DateCheck: 'Ngày kiểm tra',
		ActiveStatus: 'Tình trạng hoạt động',
		RiskStatus: 'Rủi ro về hóa đơn',
		HistoryActiveStatus: 'Lịch sử tình trạng hoạt động'
	},

	ReportInvoiceRiskBySupplier: {
		SellerName: 'Tên người bán',
		BuyerTaxCode: 'MST người mua',
		BuyerName: 'Tên người mua',
		SellerTaxCode: 'MST người bán',
		InvoiceDate: 'Ngày hóa đơn',
		SignedDate: 'Ngày ký',
		InvoiceNo: 'Số hóa đơn',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		TotalAmountWithoutVat: 'Doanh số chưa thuế',
		TotalVATAmount: 'Tiền thuế',
		TotalAmount: 'Tổng tiền',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		StatusInvoice: 'Trạng thái hóa đơn',
		ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên CQT',
		'InfoND123.BuyerFullName': 'Họ tên người mua',
		PaymentDueDate: 'Hạn thanh toán',
		TotalAmountNotPayment: 'Tiền chưa thanh toán',
		Status: 'Kết quả kiểm tra',
		Noted: 'Ghi chú',
		BranchName: 'Tên chi nhánh',
		BranchTax: 'MST chi nhánh',
		DepartmentName: 'Tên phòng ban'
	},
	ReportInvoiceBySupplierActiveList: {
		StickInfo: 'Nhãn dán',
		InvoiceDate: 'Ngày hóa đơn',
		SignedDate: 'Ngày ký',
		InvoiceNo: 'Số hóa đơn',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		SellerName: 'Nhà cung cấp',
		SellerTaxCode: 'Mã số thuế',
		SellerAddress: 'Địa chỉ NCC',
		ActiveStatus: 'Tình trạng hoạt động nhà cung cấp',
		TotalHasDiscount: 'Doanh số chưa thuế',
		TotalVATAmount: 'Tiền thuế',
		TotalAmount: 'Tổng tiền',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		Status: 'Kết quả kiểm tra',
		StatusInvoice: 'Trạng thái hóa đơn',
		NotificationWrong: 'Thông báo sai sót',
		ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên CQT',
		ChangeStatusInvoiceOnSystemDate: 'Ngày phát hiện thay đổi trạng thái',
		'InfoND123.BuyerFullName': 'Người mua hàng',
		Noted: 'Ghi chú',
		BranchName: 'Tên chi nhánh',
		BranchTax: 'MST chi nhánh',
		DepartmentName: 'Tên phòng ban'
	},
	ReportInvoiceBySupplierActiveByInvoiceDateList: {
		StickInfo: 'Nhãn dán',
		InvoiceDate: 'Ngày hóa đơn',
		SignedDate: 'Ngày ký',
		InvoiceNo: 'Số hóa đơn',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		SellerName: 'Nhà cung cấp',
		SellerTaxCode: 'Mã số thuế',
		SellerAddress: 'Địa chỉ NCC',
		ActiveStatus: 'Tình trạng hoạt động nhà cung cấp',
		TotalHasDiscount: 'Doanh số chưa thuế',
		TotalVATAmount: 'Tiền thuế',
		TotalAmount: 'Tổng tiền',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		Status: 'Kết quả kiểm tra',
		StatusInvoice: 'Trạng thái hóa đơn',
		NotificationWrong: 'Thông báo sai sót',
		ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên CQT',
		ChangeStatusInvoiceOnSystemDate: 'Ngày phát hiện thay đổi trạng thái',
		'InfoND123.BuyerFullName': 'Người mua hàng',
		Noted: 'Ghi chú',
		BranchName: 'Tên chi nhánh',
		BranchTax: 'MST chi nhánh',
		DepartmentName: 'Tên phòng ban'
	},
	CustomsDeclarationList: {
		DeclarationNo: 'Số tờ khai',
		DeclarationDate: 'Ngày tờ khai',
		CreatedDate: 'Ngày vào hệ thống',
		InvoiceNo: 'Số hóa đơn',
		ExporterName: 'Người xuất khẩu',
		BuyerTaxCode: 'Mã số thuế',
		BuyerAddress: 'Địa chỉ',
		TotalDeclarationAmount: 'Tổng trị giá hóa đơn',
		TotalDeclarationAmountExchange: 'Tổng trị giá hóa đơn quy đổi',
		TotalPreCustomsFee: 'Tổng phí trước HQ',
		TotalPreCustomsFeeExchange: 'Tổng phí trước HQ quy đổi',
		TotalTaxValue: 'Tổng trị giá tính thuế',
		TotalTaxAmount: 'Tổng tiền thuế',
		TotalPaymentAmountExchange: 'Tổng tiền thanh toán quy đổi',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		CompanyName: 'Công ty',
		CompanyTax: 'MST Công ty',
		BranchName: 'Chi nhánh',
		BranchTax: 'MST chi nhánh',
		DepartmentName: 'Phòng ban'
	},

	ReportInvoiceRelated: {
		SupplierName: 'Nhà cung cấp',
		TaxCode: 'Mã số thuế',
		InvoiceDate: 'Ngày hóa đơn',
		SignedDate: 'Ngày ký',
		InvoiceNo: 'Số hóa đơn',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		CheckingResult: 'Kết quả kiểm tra',
		TotalHasDiscount: 'Doanh số chưa thuế',
		TotalVATAmount: 'Tiền thuế',
		TotalAmount: 'Tổng tiền',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		StatusInvoice: 'Trạng thái hóa đơn',
		SearchCode: 'Mã tra cứu',
		LinkSearch: 'Link tra cứu',
		RelatedInvoiceDate: 'Ngày hóa đơn',
		RelatedInvoiceSignedDate: 'Ngày ký',
		RelatedInvoiceNo: 'Số hóa đơn',
		RelatedInvoiceTemplateNo: 'Mẫu số',
		RelatedInvoiceSeries: 'Ký hiệu',
		RelatedInvoiceCheckingResult: 'Kết quả kiểm tra',
		RelatedInvoiceTotalHasDiscount: 'Doanh số chưa thuế',
		RelatedInvoiceTotalVATAmount: 'Tiền thuế',
		RelatedInvoiceTotalAmount: 'Tổng tiền',
		RelatedInvoiceTotalAmountExchange: 'Tổng tiền quy đổi',
		RelatedInvoiceStatusInvoice: 'Trạng thái hóa đơn',
		ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên CQT',
		ChangeStatusInvoiceOnSystemDate: 'Ngày thay đổi trạng thái trên phần mềm',
		IncorrectInvoice: 'Hóa đơn sai sót',
		TransferInvoice: 'Hóa đơn thay thế, điều chỉnh'
	},
	ReportinvoiceStick: {
		StickOneName: 'Nhãn dán 1',
		StickTwoName: 'Nhãn dán 2',
		StickThreeName: 'Nhãn dán 3',
		InvoiceCount: 'Số lượng hóa đơn',
		UntaxedRevenue: 'Doanh thu chưa thuế',
		TotalConversionAmount: 'Tổng tiền quy đổi',
		TotalAmount: 'Tổng tiền',
		TotalAmountTax: 'Tiền thuế'
	},
	InvoiceListThirdParty: {
		Attached: 'Tệp',
		File: 'Tệp đính kèm',
		InvoiceNo: 'Số hóa đơn',
		InvoiceDate: 'Ngày hóa đơn',
		MCCQT: 'Mã cơ quan thuế',
		SignedDate: 'Ngày ký',
		TaxAuthorityCreatedDate: 'Ngày gửi đến CQT',
		IssueDate: 'Ngày cấp mã',
		SupplierCode: 'Mã người bán',
		SellerName: 'Tên người bán',
		SellerAddress: 'Địa chỉ người bán',
		SellerTaxCode: 'MST người bán',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		TotalHasDiscount: 'Thành tiền trước thuế',
		TotalHasDiscountCC: 'Thành tiền trước thuế quy đổi',
		TaxReduction: 'Giảm thuế',
		TotalVATAmount: 'Tổng tiền thuế',
		TotalVATAmountCC: 'Tổng tiền thuế quy đổi',
		TotalFeesAmountXML: 'Tổng tiền phí',
		AmountOtherReduction: 'Tổng giảm trừ khác',
		TotalAmount: 'Tổng tiền',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		CostNorms: 'Định mức chi phí',
		BeyondTheNorm: 'Vượt định mức',
		NonBeyondTheNorm: 'Chưa vượt định mức',
		HasPdf: 'Bản thể hiện hóa đơn',
		HasXml: 'XML hóa đơn',
		Status: 'Kết quả kiểm tra',
		CheckDate: 'Ngày kiểm tra',
		CostType: 'Loại chi phí',
		IsSendEmail: 'Trạng thái gửi email',
		StatusInvoice: 'Trạng thái hóa đơn',
		IsRelativeInvoice: 'Hóa đơn liên quan',
		WarningPaymentDueDate: 'Ngày nhắc hạn TT',
		PaymentDueDate: 'Hạn thanh toán',
		AmountPayment: 'Trạng thái thanh toán',
		PaymentNumber: 'Số lần thanh toán',
		TotalAmountNotPayment: 'Tiền chưa thanh toán',
		CheckedVatStatus: 'Kiểm tra thuế suất',
		CompanyName: 'Công ty',
		CompanyTax: 'MST công ty',
		BranchName: 'Chi nhánh',
		BranchTax: 'MST chi nhánh',
		BuyerName: 'Tên người mua',
		'InfoND123.BuyerFullName': 'Họ tên người mua',
		BuyerTaxCode: 'MST người mua',
		BuyerAddress: 'Địa chỉ người mua',
		DepartmentName: 'Phòng ban',
		BuyerInvRevEmail: 'Email nhận hóa đơn',
		Noted: 'Ghi chú',
		RefNo: 'Số chứng từ',
		AccountingDate: 'Ngày hạch toán',
		Accountant: 'Người hạch toán',
		CreatedDate: 'Ngày vào hệ thống',
		UploadFile: 'Tệp hóa đơn',
		ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên CQT',
		ChangeStatusInvoiceOnSystemDate: 'Ngày phát hiện thay đổi trạng thái',
		NotificationWrong: 'Thông báo sai sót',
		LicensePlate: 'Biển số xe',
		TypeInvoiceReceive: 'Nguồn hóa đơn'
	}
};
